export const userInputs = [
    {
      id: "email",
      type: "mail",
      placeholder: "Email",
      
    },
  
];